import { render, staticRenderFns } from "./cloud_services.vue?vue&type=template&id=768609ad&scoped=true&"
import script from "./cloud_services.vue?vue&type=script&lang=js&"
export * from "./cloud_services.vue?vue&type=script&lang=js&"
import style0 from "./cloud_services.vue?vue&type=style&index=0&id=768609ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768609ad",
  null
  
)

export default component.exports